import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Cell, ResponsiveContainer } from 'recharts';

function TimeOfDayBarChart({ data }) {
  const COLORS = ['#F59E0B', '#3B82F6', '#8B5CF6', '#475569']; // morning, afternoon, evening, night
  return (
    <ResponsiveContainer width="100%" height={250}>
      <BarChart data={data}>
        <CartesianGrid strokeDasharray="3 3" stroke="#ccc" />
        <XAxis dataKey="time" stroke="#888" tick={{ fill: '#888', fontSize: 12 }} />
        <YAxis stroke="#888" tick={{ fill: '#888', fontSize: 12 }} />
        <Tooltip />
        <Bar dataKey="count" fill="#3B82F6">
          {data.map((entry, index) => (
            <Cell key={`time-${index}`} fill={COLORS[index % COLORS.length]} />
          ))}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
}

export default TimeOfDayBarChart;

